<ion-buttons>
  <ion-button id="popover-button" fill="clear" (click)="more($event)">
    <ion-icon color="black1" name="ellipsis-vertical"></ion-icon>
  </ion-button>
</ion-buttons>
